import React, { ReactElement, useEffect } from 'react'

import Alert from '../../../../../../../1stlog-ui/src/components/Alert'
import useFieldRaw from '../../../../../../../1stlog-ui/src/components/Field/useFieldRaw'
import useFieldState from '../../../../../../../1stlog-ui/src/components/Field/useFieldState'

type ColiLimitsValidationProps = {}

export const ColiLimitsValidation = (
  props: ColiLimitsValidationProps,
): ReactElement => {
  const {} = props

  const {
    input: { value: weight },
    meta: { error: weightError },
  } = useFieldRaw<number>('weight', {
    subscription: {
      error: true,
      value: true,
    },
  })

  const {
    input: { value: length },
    meta: { error: lengthError },
  } = useFieldRaw<number>('length', {
    subscription: {
      error: true,
      value: true,
    },
  })

  const {
    input: { value: width },
    meta: { error: widthError },
  } = useFieldRaw<number>('width', {
    subscription: {
      error: true,
      value: true,
    },
  })

  const {
    input: { value: height },
    meta: { error: heightError },
  } = useFieldRaw<number>('height', {
    subscription: {
      error: true,
      value: true,
    },
  })

  const {
    input: { value: girth },
    meta: { error: girthError },
  } = useFieldRaw<number>('girth', {
    subscription: {
      error: true,
      value: true,
    },
  })

  const [, setColiHardLimitsExceeded] = useFieldState('coliHardLimitsExceeded')

  useEffect(() => {
    setTimeout(() => {
      setColiHardLimitsExceeded(
        Boolean(
          weightError || lengthError || widthError || heightError || girthError,
        ),
      )
    }, 0)
  }, [weightError, lengthError, widthError, heightError, girthError])

  if (weightError && weight > 0) {
    return (
      <Alert danger>
        {i18n.t(
          'weight_limit_exceeded_alert',
          'Die Sendung kann nicht aufgegeben werden, da Sie das maximal erlaubte Gewicht überschritten haben',
        )}{' '}
        ({weightError} kg).{' '}
        {i18n.t(
          'please_contact_your_shipping_partner',
          'Bitte kontaktieren Sie Ihren Versandpartner für weitere Versandoptionen.',
        )}
      </Alert>
    )
  }

  if (lengthError && length > 0) {
    return (
      <Alert danger>
        {i18n.t(
          'length_limit_exceeded_alert',
          'Die Sendung kann nicht aufgegeben werden, da Sie die maximale Länge überschritten haben',
        )}{' '}
        ({lengthError} cm).{' '}
        {i18n.t(
          'please_contact_your_shipping_partner',
          'Bitte kontaktieren Sie Ihren Versandpartner für weitere Versandoptionen.',
        )}
      </Alert>
    )
  }

  if (widthError && width > 0) {
    return (
      <Alert danger>
        {i18n.t(
          'width_limit_exceeded_alert',
          'Die Sendung kann nicht aufgegeben werden, da Sie die maximale Breite überschritten haben',
        )}{' '}
        ({widthError} cm).{' '}
        {i18n.t(
          'please_contact_your_shipping_partner',
          'Bitte kontaktieren Sie Ihren Versandpartner für weitere Versandoptionen.',
        )}
      </Alert>
    )
  }

  if (heightError && height > 0) {
    return (
      <Alert danger>
        {i18n.t(
          'height_limit_exceeded_alert',
          'Die Sendung kann nicht aufgegeben werden, da Sie die maximale Höhe überschritten haben',
        )}{' '}
        ({heightError} cm).{' '}
        {i18n.t(
          'please_contact_your_shipping_partner',
          'Bitte kontaktieren Sie Ihren Versandpartner für weitere Versandoptionen.',
        )}
      </Alert>
    )
  }

  if (girthError && girth > 0) {
    return (
      <Alert danger>
        {i18n.t(
          'girth_limit_exceeded_alert',
          'Die Sendung kann nicht aufgegeben werden, da Sie das maximale Gurtmaß überschritten haben',
        )}{' '}
        ({girthError} cm).{' '}
        {i18n.t(
          'please_contact_your_shipping_partner',
          'Bitte kontaktieren Sie Ihren Versandpartner für weitere Versandoptionen.',
        )}
      </Alert>
    )
  }

  return <></>
}
